import React from "react";
import { useAppStore } from "../../stores/useAppStore";
import {
  Hidden,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Snackbar
} from "@mui/material";
import * as ErrorHelper from "../../helpers";


const MessageBoxContainer = () => {
  const error = useAppStore(state => state.error);
  const { message, onCloseHandler, title, action } = error;

  const handleClose = () => {
    if (onCloseHandler !== null) {
      onCloseHandler();
    }
    ErrorHelper.resetError();
  }

  if (!message) {
    return null;
  }

  return (
    <>
      <Hidden only={["sm", "md", "lg", "xl"]}>
        <Snackbar
          open
          onClose={handleClose}
          ContentProps={{
            "aria-describedby": "snackbar-fab-message-id"
          }}
          message={<span id="snackbar-fab-message-id">{message}</span>}
          action={
            <Button color="inherit" size="small" onClick={handleClose}>
              {action}
            </Button>
          }
        />
      </Hidden>
      <Hidden only={["xs"]}>
        <Dialog
          open
          fullWidth
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" autoFocus>
              {action}
            </Button>
          </DialogActions>
        </Dialog>
      </Hidden>
    </>
  );
}

export default MessageBoxContainer;
